
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class BacAccordeon extends Vue {
    @Prop({ default: '' }) title!: string
}
